

export class WorkflowListUiVo {

  uuid: string | null = null;
  name: string | null = null;
  defaultLabel: string | null = null;
  systemName: string | null = null;
  definitionFile: string | null = null;
  valid: boolean | null = null;
  validFrom: Date | null = null;
  validTo: Date | null = null;
  configuredBy: string | null = null;
  configuredForOwner: boolean | null = null;

}
